import { format } from 'date-fns';

export const timeFormat = (date: string) => {
  return format(new Date(date), 'dd-MMM-yyyy hh:mm a');
};

export const dateFormat = (date: string, dFormat: any = 'dd-MMM-yyyy') => {
  return format(new Date(date), dFormat);
};
